import React, { useState } from "react";
import axios from "axios";
import { path } from "../../path";

const CreateAdModal = ({
  AdModal,
  setAdModal,
  selectedAdvertiser,
  fetchAdvertiserData,
}) => {
  const initialAdData = {
    title: AdModal?.ad?.title || "",
    description: AdModal?.ad?.description || "",
    actionText: AdModal?.ad?.action?.buttonText || "",
    actionLink: AdModal?.ad?.action?.link || "",
    actionMessageBody: AdModal?.ad?.action?.message?.body || "",
    expiresAt: AdModal?.ad?.expiresAt?.split("T")[0] || "",
  };
  const [adData, setAdData] = useState(initialAdData);
  const [adMediaFile, setAdMediaFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionType, setActionType] = useState("link");
  const [actionNumber, setActionNumber] = useState();

  const handleChange = (ev) => {
    console.info(initialAdData)
    setAdData((prev) => ({
      ...prev,
      [ev.target.name]: ev.target.value,
    }));
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
  
    let updatedAdData = { ...adData };
  
    if (actionType === "number" && actionNumber) {
      updatedAdData.actionLink = `tel:${actionNumber}`;
    }
    else if(actionType === "whatsapp_number" && actionNumber){
      updatedAdData.actionLink = `https://wa.me/${actionNumber}`
    }
  
    // Validate required fields
    if (
      !updatedAdData.title ||
      !updatedAdData.description ||
      !updatedAdData.actionText ||
      !updatedAdData.actionLink ||
      !updatedAdData.actionMessageBody
    ) {
      console.info(updatedAdData);
      alert("All fields are required!");
      return;
    }
  
    if (AdModal.type === "createAd" && !adMediaFile) {
      alert("Media file is required");
      return;
    }
  
    try {
      setLoading(true);
  
      const formData = new FormData();
      if (adMediaFile) {
        formData.append("mediaFile", adMediaFile);
      }
  
      // Append all `updatedAdData` fields
      Object.keys(updatedAdData).forEach((key) => {
        formData.append(key, updatedAdData[key]);
      });
  
      let response;
      if (AdModal.type === "editAd") {
        if (!AdModal?.ad?._id) {
          alert("Invalid advertisement ID");
          return;
        }
        response = await axios.put(
          `${path}/advertisement/${AdModal.ad._id}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
      } else {
        if (!selectedAdvertiser?._id) {
          alert("Invalid advertiser ID");
          return;
        }
        response = await axios.post(
          `${path}/advertisement/${selectedAdvertiser._id}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
      }
  
      if (response.status === 200) {
        alert("Ad uploaded successfully!");
        setAdData(initialAdData);
        setAdMediaFile(null);
        setAdModal({ type: null, ad: null });
      }
    } catch (error) {
      console.error("Error uploading ad:", error);
    } finally {
      setLoading(false);
      if (selectedAdvertiser?._id) {
        fetchAdvertiserData(selectedAdvertiser._id);
      }
    }
  };
  


  return (
    <div className="fixed w-full h-screen bg-black/40 flex items-center justify-center inset-0 z-20">
      {loading && (
        <div className=" fixed w-full h-screen bg-black/40 flex items-center justify-center inset-0 z-20">
          <div className=" flex items-center gap-2">
            <div className=" w-8 h-8 rounded-full border-2 border-teal-500 border-t-white animate-spin" />
            <p className=" text-lg text-white font-semibold">
              {AdModal.type === "createAd" ? "Creating.." : "Editing.."}
            </p>
          </div>
        </div>
      )}
      <div className=" relative w-full max-w-4xl bg-white rounded-xl p-10 flex flex-col items-center gap-4 overflow-scroll h-[80%]">
        <span
          onClick={() => setAdModal({ type: null, ad: null })}
          className=" absolute top-2 right-2 cursor-pointer">
          X
        </span>
        <h1 className=" text-gray-800 text-xl font-semibold">
          {" "}
          {AdModal.type === "createAd" ? "Create New Ad" : "Edit new Ad"}
        </h1>
        <form className="space-y-2 py-10 w-[80%]" onSubmit={handleSubmit}>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Title
            </label>
            <input
              type="text"
              name="title"
              value={adData.title}
              onChange={handleChange}
              className=" block w-full rounded-md border border-blue-800 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Description
            </label>
            <textarea
              type="text"
              name="description"
              rows={4}
              value={adData.description}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border border-blue-800 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Action Text
            </label>
            <input
              type="text"
              name="actionText"
              value={adData.actionText}
              onChange={handleChange}
              className=" block w-full rounded-md border border-blue-800 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Action Type:
            </label>
            <div className="flex items-center gap-4 mt-2">
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  value="link"
                  checked={actionType === "link"}
                  onChange={() => setActionType("link")}
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                />
                <span>Link</span>
              </label>

              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  value="number"
                  checked={actionType === "number"}
                  onChange={() => setActionType("number")}
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                />
                <span>Phone Number</span>
              </label>

              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  value="whatsapp_number"
                  checked={actionType === "whatsapp_number"}
                  onChange={() => setActionType("whatsapp_number")}
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                />
                <span>Whatsapp Number</span>
              </label>
            </div>
          </div>

          {actionType === "link" ? (
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Action Link
              </label>
              <input
                type="text"
                name="actionLink"
                value={adData.actionLink}
                onChange={handleChange}
                className=" block w-full rounded-md border border-blue-800 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
              />
            </div>
          ) : (
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Action Number
              </label>
              <input
                type="number"
                name="actionNumber"
                value={actionNumber}
                onChange={(ev) => setActionNumber(ev.target.value)}
                className=" block w-full rounded-md border border-blue-800 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Action Message Body
            </label>
            <textarea
              type="text"
              name="actionMessageBody"
              rows={4}
              value={adData.actionMessageBody}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border border-blue-800 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label
              className="block text-gray-700 font-medium mb-2"
              htmlFor="file">
              Ad Media
            </label>
            <input
              type="file"
              id="mediaFile"
              multiple={false}
              accept="image/*,video/*"
              onChange={(ev) => setAdMediaFile(ev.target.files[0])}
              className="w-full px-4 py-2 border rounded-md focus:outline-none"
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="expiresAt"
              className="block text-sm font-medium text-gray-700">
              Expiry Date:
            </label>
            <input
              type="date"
              name="expiresAt"
              value={adData?.expiresAt}
              onChange={handleChange}
              className="mt-2 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="bg-teal-500 text-white px-4 py-2 rounded-md">
            {AdModal.type === "createAd" ? "Create" : "Edit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateAdModal;
